export default __webpack_public_path__ + "static/media/expressjs-icon.632d3c32.svg";